import classNames from 'classnames';
import React from 'react';

import { POSITION, SIZE } from './constants';
import { TPosition, TSize } from './interface';
import { Tab } from './Tab';
import styles from './tabs.module.scss';

interface ITabsProps {
  className?: string;
  items: string[];
  position?: TPosition;
  size?: TSize;
  active?: number;
  onChange?: (value: any) => void;
}

const Tabs: React.FC<ITabsProps> = React.memo((props) => {
  const { position = POSITION.LEFT, size = SIZE.DEFAULT, items = [], className, active = 0, onChange } = props;

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (onChange) onChange(+event.target.value);
  }

  function renderTabs() {
    return items.map((tabName, index) => (
      <Tab key={`tab-${index}`} text={tabName} index={index} active={index === active} onChange={handleChange} />
    ));
  }

  return (
    <div className={classNames(className, styles.wrapper, styles[`wrapper--size-${size}`])}>
      <div
        className={classNames(styles.group, styles[`group--size-${size}`], styles[`group--position-${position}`])}
        role="tablist"
      >
        {renderTabs()}
      </div>
    </div>
  );
});

export default Tabs;
